import { arrayOf, func, number } from 'prop-types';
import React from 'react';
import { ModalBody, ModalHeader } from 'reactstrap';

import createModalToggle from '../../../generic/create-modal-toggle';
import { productShape } from '../../../prop-types';
import BookingEntryModalLink from './BookingEntryModalLink';
import UpdateBookingEntryContainer from './UpdateBookingEntry.container';

function UpdateBookingEntryModal({
  id,
  invoiceId,
  products,
  onSuccess,
  toggle,
}) {
  return (
    <>
      <ModalHeader toggle={toggle}>Update Booking Entry</ModalHeader>
      <ModalBody>
        <UpdateBookingEntryContainer
          id={id}
          invoiceId={invoiceId}
          products={products}
          onSuccess={onSuccess}
        />
      </ModalBody>
    </>
  );
}

UpdateBookingEntryModal.propTypes = {
  id: number.isRequired,
  products: arrayOf(productShape.isRequired).isRequired,
  onSuccess: func.isRequired,
  toggle: func.isRequired,
  invoiceId: number,
};

UpdateBookingEntryModal.defaultProps = {
  invoiceId: undefined,
};

export default createModalToggle(
  ({ id }) => <BookingEntryModalLink id={id} />,
  UpdateBookingEntryModal,
  { color: '', className: 'p-0' },
  { size: 'lg' },
);
export { UpdateBookingEntryModal }; // for unit tests
